import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormBuilder, FormArray, FormGroup, FormControl } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { LimitFlowProposalService } from '../../service/limit-flow-proposal/limit-flow-proposal.service';
import { ConcentreComponent } from '../../../serasa/component/serasa/concentre/concentre.component';
import { RelatoComponent } from '../../../serasa/component/serasa/relato/relato.component';
import { CrednetComponent } from '../../../serasa/component/serasa/crednet/crednet.component';
import { AccountClientDetailsService } from '../../../account-client/service/account-client-edit/account-client-details.service';
import { CommonService } from '../../../common/service/common.service';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { Subscription } from "rxjs/Rx";
import { GuaranteeSummaryModalComponent } from "./guarantee-modal/guarantee-modal.component";
import { ReferenceSummaryModalCommponent } from "./reference-modal/reference-modal.component";

@Component({
	selector: 'app-summary',
	templateUrl: './summary.component.html',
	styleUrls: ['./summary.component.scss'],
	providers: [
		CommonService,
		AccountClientDetailsService
	]
})
export class SummaryComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('accountClientID') accountClientID: string = "";
	@Input('proposalLayout') proposalLayout: number = 0;
	@Input('tempGroup') tempGroup: any[] = [];
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	revenueRural: FormGroup;
	private token;
	public garantias: any[] = [];
	public referencias: any[] = [];
	public culturas: any[] = [];
	public lcProposto: number = 0;
	public clientName: string = "";
	public GC: string = "";
	public CTC: string = "";
	public clientType: string = "";
	public summaryPjDRE: any;
	public ParecerAnalista: string = "";
	public clientHistory: any[] = [];
	public clientHistoryGroup: any[] = [];
	public proposalSubcription = new Subscription;

	constructor(
		private fb: FormBuilder, 
		private dialogService: DialogService, 
		private accountClientDetailsService: AccountClientDetailsService, 
		private limitFlowProposalService: LimitFlowProposalService, 
		private flashMessagesService: FlashMessagesService, 
		private commonService: CommonService) {
	}

	ngOnInit() {
		this.token = localStorage.getItem('yara.token');
		this.getUserInfos();
		this.getCommercialStructureInfos();

		console.log('this.limitFlowProposalService.proposalObj[\'AnaliseGrupo\']: ', this.limitFlowProposalService.proposalObj['AnaliseGrupo']);
		console.log('this.limitFlowProposalService.proposalObj[\'GrupoEconomicoID\']: ', this.limitFlowProposalService.proposalObj['GrupoEconomicoID']);

		if (this.proposalLayout === 1 || this.proposalLayout === 6 || this.proposalLayout === 7) {
			if (this.getPotencialPatrimonial() > this.getPotencialReceita()) {
				this.limitFlowProposalService.proposalObj['PotencialCredito'] = this.getPotencialReceita();
			} else {
				this.limitFlowProposalService.proposalObj['PotencialCredito'] = this.getPotencialPatrimonial();
			}
			$("#PotencialCreditoPF").val(this.limitFlowProposalService.proposalObj['PotencialCredito']);
		}
		
		var dre = $("#dreObj").val() ? JSON.parse($("#dreObj").val().toString()) : [];

		this.getFinancialDemosById(dre.DemonstrativoFinanceiroID);

		if (this.limitFlowProposalService.proposalObj['AnaliseGrupo'] && this.grupoNotNullOrEmpty()) {
			this.getAccountHistoryGroup(this.limitFlowProposalService.proposalObj['GrupoEconomicoID']);
		} else {
			this.getAccountHistory();
		}
	}

	grupoNotNullOrEmpty(){
		return this.limitFlowProposalService.proposalObj['GrupoEconomicoID'] != null && this.limitFlowProposalService.proposalObj['GrupoEconomicoID'] !== '';
	}

	getDescRestricao(tipo) {
		var msg;
		switch (+tipo) {
			case 1:
				msg = "Sim - Relevante";
			break;
			case 2:
				msg = "Sim - Não Relevante";
			break;
			case 3:
				msg = "Não";
			break;
			default:
			break;
		}

		return msg;
	}

	ngOnDestroy() {
		this.proposalSubcription.unsubscribe();
	}

	getAccountHistoryGroup(idGroup) {
		this.limitFlowProposalService.accountHistoryGroup(idGroup).subscribe(result => {
			if (result.Success) {
				this.clientHistoryGroup = result.Result;
				setTimeout(function(){ 
					($('[data-toggle="culture-tooltip"]') as any).tooltip();
				}, 0);
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	getAccountHistory() {
		this.limitFlowProposalService.accountHistory(this.accountClientID).subscribe(result => {
			if (result.Success) {
				this.clientHistory = result.Result;
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	getFinancialDemosById(id) {
		if (id) {
			this.limitFlowProposalService.getFinancialDemosById(id).subscribe(result => {
				if (result.Success) {
					this.summaryPjDRE = result.Result.HtmlResumo;
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
				return false;
			});
		}
	}

	getUserInfos() {
		this.limitFlowProposalService.getUserInfos(this.accountClientID).subscribe(result => {
			if (result.Success) {
				this.clientName = result.Result.Nome;
				this.clientType = result.Result.TipoCliente.Nome;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	getCommercialStructureInfos() {
		this.limitFlowProposalService.getCommercialStructureInfos(this.limitFlowProposalService.proposalObj['CodigoSap']).subscribe(result => {
			if (result.Success) {
				if (result.Result) {
					this.GC = result.Result.Superior ? result.Result.Superior.Nome : "";
					this.CTC = result.Result.Nome;
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	getPotencialPatrimonial() {
		return Number($("#valorTotalBensRurais").val()) + Number($("#valorTotalBensUrbanos").val()) + Number($("#valorTotalMaquinasEquipamentos").val());
	}

	getPotencialReceita() {
		return Number($("#receitaTotal").val());
	}

	setParecerAnalista(value) {
		$("#ParecerAnalista").val(value);
	}

	openReferencia(referencia) {
		let disposable = this.dialogService.addDialog(ReferenceSummaryModalCommponent, {
			referencia: referencia,
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
			});
	}

	openGarantia(garantia) {
		let disposable = this.dialogService.addDialog(GuaranteeSummaryModalComponent, {
			garantia: garantia,
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
			});
	}

	openSerasa(id, tipoConsulta) {
		if (id) {
			this.accountClientDetailsService.requestSerasaByID(id).subscribe(result => {
				if (result.Success) {
					this.showModal(result.Result, tipoConsulta);
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
					console.log(result);
				}
			}, error => {
				this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
			});
		} else {
			this.flashMessagesService.show("A consulta ao SERASA ainda não foi realizada", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	showModal(serasaByIdObj, tipoConsulta) {
		if (tipoConsulta == 1) {
			this.dialogService.addDialog(ConcentreComponent, { serasaObj: serasaByIdObj }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
		} else if (tipoConsulta == 2) {
			this.dialogService.addDialog(CrednetComponent, { serasaObj: serasaByIdObj }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
		} else if (tipoConsulta == 3) {
			this.dialogService.addDialog(RelatoComponent, { serasaObj: serasaByIdObj }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
		} else {
			console.log("Tipo de Consulta não reconhecida!");
		}
	}

	getRentabilidade(cultura) {
		var calc = (this.getReceitaLiquida(cultura) / this.getReceitaBruta(cultura));
		return Number(calc * 100).toFixed(2);
	}

	getReceitaLiquida(cultura) {
		return this.getReceitaBruta(cultura) - this.getCustosTotais(cultura);
	}

	getReceitaBruta(cultura) {
		var porcentagem = parseFloat(cultura.Quebra);
		var count = porcentagem ? 1 - (porcentagem / 100) : 1;

		return ((cultura.Area + cultura.Arrendamento) * cultura.ProdutividadeMedia * cultura.Preco) * count; 
	}

	getCustosTotais(cultura) {
		return ((cultura.Area + cultura.Arrendamento) * cultura.CustoHa) + 
		((cultura.Preco * cultura.CustoArrendamentoSacaHa) * cultura.Arrendamento);
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/summary/summary.component.ts